window.addEventListener('DOMContentLoaded', () => {
  $('#completeAlert').hide();
  $('.print').hide();
  let video = $('#videoContent');
  let time_played = 0;
  let time_started = 0;

  let print_link = $('.share-icon__link');
  const print_url = print_link.attr('href');
  video.bind('ended', function () {
    $.post('/trainings/' + $('#trainingId').val() + '/create_view_history', function (data) {
      $('#completeAlert').show();
      $('.print').show();
      print_link.attr('href', print_url + '?time_watched=' + secondsToMs(time_played))
    });
    $('#timeWatched').text('視聴時間： ' + secondsToMs(time_played));
  });

  video.bind('playing', function () {
    time_started = new Date().getTime()/1000;
  });

  video.bind('pause', function () {
    if(time_started > 0) {
      time_played += new Date().getTime() / 1000 - time_started;
      time_started = -1;
    }
  });

  $('#closePopup').click(() => {
    $('#completeAlert').hide();
  })

  function secondsToMs(seconds) {
    seconds = Number(seconds);
    let m = Math.floor(seconds / 60);
    let s = Math.floor(seconds % 60);
    if(m < 10) { m = '0' + m }
    if(s < 10) { s = '0' + s }

    return m + "分" + s + "秒";
  }
})
